// extracted by mini-css-extract-plugin
export default {"DropdownMenuItem":"actionsMenu_DropdownMenuItem__ctcpw"};